module.exports = __webpack_public_path__ + "media/assets/images/personas/leonardo_schema-2d44bc3c110a121a41d0dd8dba13269b.png";